module.exports = __webpack_public_path__ + "static/media/image_55.1b7ebde9.png";